import React, { useContext } from 'react';
import styled from 'styled-components';
import { IPanelEstructureElementConj } from '../../../../types/panelEstructure';
import PanelEstructureContext from '../context/PanelEstructureContext';

export type IProps = {
  data: IPanelEstructureElementConj;
};

const PanelBlockElementConjugation: React.FC<IProps> = ({ data }) => {
  const panelEstructureContext = useContext(PanelEstructureContext);

  const getSource = (): string => {
    const source = data.sources.find((d) => d.dialectId === panelEstructureContext.sourceDialectId);
    if (source) {
      return source.html;
    } else {
      return '';
    }
  };

  const html = getSource();

  return <Wrapper dangerouslySetInnerHTML={{ __html: html }} />;
};

export default PanelBlockElementConjugation;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
